import explorer from './Explorer';

const crepoReducers = () => ({
  explorer
});

export default crepoReducers;
